import styled from 'styled-components';
import tw from 'twin.macro';

export const ProgressBarContainer = styled.div`
  ${tw`w-full bg-blue-gray-200`}
`;

export const ProgressBar = styled.div`
  ${tw`bg-blue-gray-600 h-6px rounded-tr-full rounded-br-full`}
  ${(props) => `width: ${props.width}%`};
`;
